<template>
    <div>
        <transition name="fade-down" appear>
            <div v-show="visible" class="dialog dialog--display dialog--scrollable">
                <div class="spring dialog__close-spring">
                    <a @click.prevent="hide" href="" class="dialog__close" style="display: inline-block">
                        <svg focusable="false" aria-hidden="true" class="icon icon--small dialog__icon">
                            <use xlink:href="#icon-close"></use>
                        </svg>
                    </a>
                </div>
                <div class="country-selector-full__content dialog__content text-center">
                    <div class="ajax">
                        <h2 class="heading heading--1 heading--light heading--center">Introdu destinația ta</h2>
                        <div class="spring">
                            <div class="search-snack__input">
                                <input ref="searcInput" v-model="countryInput" @keyup.esc="hide" @keypress.enter="handleSearchEnter" class="input-group__input form__input form__text" placeholder="e.g. Franța" type="text" autocomplete="off" />
                            </div>
                            <div class="country-none" v-show="matchedCountries.length === 0 && countryInput !== ''">Nu s-au găsit rezultate pentru "{{ countryInput }}"</div>
                            <ul class="matched-countries">
                                <li v-for="country in matchedCountries.slice(0, 3)" :key="country.name">
                                    <a @click.prevent="handleCountryClick(country)">{{ country.name }}</a>
                                </li>
                            </ul>
                            <div class="section section--gutter">
                                <h3 class="heading heading--3 heading--center heading--leading space--bottom search-snack__heading">Căutări populare</h3>
                                <ul class="popular-countries">
                                    <li v-for="index in $root.popularCountries" :key="index">
                                        <a @click.prevent="handlePopularCountryClick(index)" href="">
                                            <img :src="'https://static.vodafone.ro/roaming/images/countries/cntr-flag-' + $root.countries[index].flagURL + '.png'" alt="" />
                                            {{ $root.countries[index].name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import H from './../modules/helpers.js';

export default {
    name: 'CountrySelectorFull',
    data() {
        return {
            visible: false,
            countryInput: '',
            matchedCountries: [],
            limitationList: 2,
        };
    },
    watch: {
        countryInput: function (value, oldValue) {
            var matchedCountries = [];
            if (value !== '') {
                this.$root.countries.forEach((country) => {
                    if (H.removeAccents(country.name.toLowerCase()).indexOf(H.removeAccents(value.toLowerCase())) !== -1) {
                        matchedCountries.push(country);
                    }
                });
            }
            this.matchedCountries = matchedCountries;
        },
    },
    methods: {
        show() {
            this.visible = true;
            this.countryInput = '';
            this.$nextTick(() => {
                this.$refs.searcInput.focus();
            });
        },
        hide() {
            this.visible = false;
        },
        updateRouteCountry() {
            this.$router.push({ name: 'destinatie', params: { country: this.$root.selectedCountry.nameClean } });
        },
        handleCountryClick(country) {
            this.$root.selectedCountry = country;
            this.hide();
            if (country.name === this.$root.selectedCountry.name) {
                this.hide();
            } else {
                this.updateRouteCountry();
            }
        },
        handlePopularCountryClick(index) {
            this.$root.selectedCountry = this.$root.countries[index];
            this.hide();
            this.updateRouteCountry();
        },
        handleSearchEnter() {
            if (this.matchedCountries.length === 1) {
                this.$root.selectedCountry = this.matchedCountries[0];
                this.hide();
                this.updateRouteCountry();
            }
        },
    },
};
</script>
